import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import { GridColumn, GridRow, Modal } from "arv-reactcomponents";
import { ORDERDETAILS } from "npmlinks-constants";
import Anchor from "../../Anchor";
import GetRating from "../../../component/PdpComponents/RatingAndReview/GetRating";
import { REVIEW,REVIEWS_DELIVERY_CONFIRMATION } from "npmlinks-constants";
import GetRatingAndReview from "../../../component/PdpComponents/RatingAndReview/GetRatingAndReview";
import ReviewUpdatePage from "../../../component/PdpComponents/RatingAndReview/ReviewUpdatePage";
import CustomerReviewPage from "../../../component/PdpComponents/RatingAndReview/CustomerReviewPage";
const {
  ORDER_DETAILS: { DELIVERY_STATUS_TITLE },
  EXCHANGE_INFO
} = ORDERDETAILS;

class ConsignmentDelivery extends PureComponent {
  static getDeliveryMap(deliveryState) {
    const [title] = Object.keys(deliveryState);
    const { statusText, date, state } = deliveryState && deliveryState[title];
    const disabled = state === 0 ? "nw-disabled" : "";
    const iconDisabled = state === 1 ? "nwc-hide" : "";
    return {
      title,
      statusText,
      date,
      state,
      disabled,
      iconDisabled
    };
  }
  constructor() {
    super();
    this.state = {
      returnInfo: false,
      modalOpen: false,
    };
    this.deliveryMap = this.deliveryMap.bind(this);
    this.showReturnInfo = this.showReturnInfo.bind(this);
    this.closeReturnInfoModal = this.closeReturnInfoModal.bind(this);
    this.isProductPacked = this.isProductPacked.bind(this);
  }
  

  deliveryMap(deliveryArray) {
    return (
      deliveryArray &&
      deliveryArray.map((deliveryState, index) => {
        const {
          title,
          statusText,
          date,
          state,
          disabled,
          iconDisabled
        } = ConsignmentDelivery.getDeliveryMap(deliveryState);
        return (
          <GridColumn className="nw-consignment-status" key={index}>
            <div className="nw-consignment-statustitle">{title}</div>
            <div
              className={`nw-consignment-checkicon nw-consignment-check ${disabled}`}
            >
              <i className={`icomoon-check ${iconDisabled}`} />
            </div>
            <div className="nw-consignment-statustext">{statusText}</div>
            <div className="nw-consignment-status-date">{date}</div>
          </GridColumn>
        );
      })
    );
  }

  showReturnInfo() {
    this.setState({ returnInfo: true });
  }

  closeReturnInfoModal() {
    this.setState({ returnInfo: false });
  }

  isProductPacked(deliveryArray) {
    let delivered = {};
    let packed = {};
    deliveryArray.forEach(item => {
      const [title] = Object.keys(item);
      const { state } = item[title];
      if (title && title === "Packed") {
        packed["state"] = state;
      } else if (title && (title === "Delivery" || title === "Delivered")) {
        delivered["state"] = state;
      }
    });
    return packed && packed.state && delivered && delivered.state <= 1
      ? true
      : false;
  }

  render() {
    const {
      itemDeliveryStates,
      itemReturnStatesDetails,
      itemDeliveryDateInfo
    } = this.props;
    const { returnInfo } = this.state;
    let deliveryStates = [];
    if (itemDeliveryStates && itemDeliveryStates.length > 0) {
      deliveryStates = this.deliveryMap(itemDeliveryStates);
    } else if (itemReturnStatesDetails && itemReturnStatesDetails.length > 0) {
      deliveryStates = this.deliveryMap(itemReturnStatesDetails);
    }

    return (
      <Fragment>
        <div className="nw-consignment-subtitle nw-consignment-delivery">
          {DELIVERY_STATUS_TITLE}
        </div>
        <GridRow className="nw-consignment-deliverystatus">
          {deliveryStates}
        </GridRow>
        <div className="nw-consignment-estimate">
          {itemDeliveryDateInfo}
          {this.isProductPacked(itemDeliveryStates) && (
            <div onClick={this.showReturnInfo}>
              <br />
              <div className="nw-returnexchange-infolink">
                {EXCHANGE_INFO.RETURN_EXCHANGE_INFO_CTA_TEXT}
              </div>
            </div>
          )}
        </div>
       
        <Modal isOpen={returnInfo} onClose={this.closeReturnInfoModal}>
          <div className="nw-orderdetails-returninfo">
            {EXCHANGE_INFO.DELIVERY_MARK_TEXT} <br />
            <br />
            {EXCHANGE_INFO.DELIVERY_INITIATE_TEXT}
            <Anchor.component
              className="nw-returnexchange-infolink"
              to={EXCHANGE_INFO.FAQ_EXCHANGE_LINK}
              href={EXCHANGE_INFO.FAQ_EXCHANGE_LINK}
              target="_blank"
            >
              {EXCHANGE_INFO.KNOW_MORE_LINK_TEXT}
            </Anchor.component>
          </div>
        </Modal>

      </Fragment>
    );
  }
}

ConsignmentDelivery.defaultProps = {
  itemDeliveryStates: [],
  itemReturnStatesDetails: [],
  itemDeliveryDateInfo: ""
};

ConsignmentDelivery.propTypes = {
  itemDeliveryStates: PropTypes.arrayOf(PropTypes.object),
  itemDeliveryDateInfo: PropTypes.string,
  itemReturnStatesDetails: PropTypes.arrayOf(PropTypes.object)
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ConsignmentDelivery,
  component: ConsignmentDelivery
};

export default ProjectComponent;
